// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"ChatLoader_loaderOverlay__HqD4U","loaderContainer":"ChatLoader_loaderContainer__Hom76"};